import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, salesDepartment } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },

}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const LostDataAnalysis = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [store, setStore] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("lost")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [selectedDepartment, setSelectedDepartment] = useState("")
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']

    useEffect(() => {
        expCenters();
        locations();
        fetchUsersData();
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            lostDataAnalysis()
            setSelectedRole(ROLENAME.SalesUser)
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            lostDataAnalysis()
            setSelectedRole(ROLENAME.DesignUser)
        } else {
            setSelectedRole("ALL")
            lostDataAnalysis();
        }
    }, []);

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "currentStage", label: "Current Stage" },
        { key: "logsStage", label: "Logs Stage" },
        { key: "salesStage", label: "Sales Stage" },
        { key: "lostStage", label: "Lost Stage" },
        { key: "department", label: "Department" }

    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.leadId?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.leadId?.lead_no || "N/A",
                    clientName: popMonthData[i]?.leadId?.customerId?.name,
                    totalValue:
                        (popMonthData[i]?.leadId?.staticSalesWonBudget),
                    location: popMonthData[i]?.salesExpCenter?.locationId?.name,
                    expCtrName: popMonthData[i]?.salesExpCenter?.name,
                    salesWonDate: popMonthData[i]?.SalesWonDate
                        ? moment(popMonthData[i]?.SalesWonDate).format("DD-MM-YYYY")
                        : "-",
                    salesUser: popMonthData[i]?.salesUser ? popMonthData[i]?.salesUser?.name : 'NA',
                    salesManager: popMonthData[i]?.salesManager ? popMonthData[i]?.salesManager?.name : 'NA',
                    salesDGM: popMonthData[i]?.salesDGM ? popMonthData[i]?.salesDGM?.name : 'NA',
                    salesAssistantManager: popMonthData[i]?.salesAssistantManager ? popMonthData[i]?.salesAssistantManager?.name : 'NA',

                    designUser: popMonthData[i]?.designUser ? popMonthData[i]?.designUser?.name : 'NA',
                    designManager: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : 'NA',
                    designDGM: popMonthData[i]?.designDGM ? popMonthData[i]?.designDGM?.name : 'NA',
                    designAssistantManager: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : 'NA',
                    currentStage: popMonthData[i]?.leadId?.currentStage ? popMonthData[i]?.leadId?.currentStage : 'NA',
                    logsStage: popMonthData[i]?.leadId?.currentStage ? popMonthData[i]?.leadId?.currentStage : 'NA',
                    salesStage: popMonthData[i]?.leadId?.currentStage ? popMonthData[i]?.leadId?.currentStage : 'NA',
                    lostStage: popMonthData[i]?.leadId?.currentStage ? popMonthData[i]?.leadId?.currentStage : 'NA',
                    department: popMonthData[i]?.leadId?.departmentId?.name ? popMonthData[i]?.leadId?.departmentId?.name : 'NA',
                    designStage: popMonthData[i]?.stage ? popMonthData[i]?.stage : "NA",
                    reasonDesignHold: popMonthData[i]?.leadId?.designHoldSelectedTypes ? popMonthData[i]?.leadId?.designHoldSelectedTypes : '-',
                    probableRestartingDate: popMonthData[i].leadId?.proposedDesignStartDate ?
                        moment(popMonthData[i]?.leadId?.proposedDesignStartDate).format('DD-MM-YYY') : "-",
                    probableDesignSignOffDate: popMonthData[i].leadId?.probableDesignSignOffDate ?
                        moment(popMonthData[i].leadId?.probableDesignSignOffDate).format('DD-MM-YYY') : "-",
                    adm: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : "-",
                    operationDM: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : "-",
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     location: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     HoldRevocationDate: "",
                // };
                // csvArray.push(obj);
            }

            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const lostDataAnalysis = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : "",
            department: selectedDepartment ? selectedDepartment : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.lostDataAnalysis(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        lostDataAnalysis(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        lostDataAnalysis(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const handleSelectChange = async (event) => {
        setSelectedValue(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            users: users ? users : "",
            userLocation: userDetails.selectedLocation,
            userExpCenter: userDetails.selectedExpCenter,
            tokenPercentage: event.target.value !== "" ? event.target.value : "",
            lost: selectLost !== "" ? selectLost : "",
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput !== "" ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.lostDataAnalysis(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }



    const handleSelectDepartment = (event) => {
        setSelectedDepartment(event.target.value)
    }

    const handleSelectRoles = async (event, role) => {
        setSelectedUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRole(event.target.value)
            obj.role = event.target.value
        }
        obj.pivotValue = pivot
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            if (!role) {
                lostDataAnalysis(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
            }
            setUsersData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const fetchUsersData = async () => {
        let obj = {}
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.role = ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.role = ROLENAME.DesignUser            
        } else {
            obj.role = "ALL"
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error,"error")
        }
    }

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }
    const handleExpData = async (newvalue) => {
        props.setLoading(true);
        await lostDataAnalysis(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newValue) => {
        props.setLoading(true);
        await lostDataAnalysis(newValue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
        handleUsersData(newvalue)
    }

    const handleUsersData = async (newvalue) => {
        props.setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRole
        }
        await lostDataAnalysis(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const lostDataBasedOnClick = async (e, month, innerEl, val) => {
        let obj = {}
        let users = ''
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        if (val === 'value') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                lost: selectLost !== "" ? selectLost : "",
                pivotValue: 'value',
                selectedRole: selectedRole ? selectedRole : "",
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                users: users ? users : "",
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : "",
                department: selectedDepartment ? selectedDepartment : ""
            }
            if (innerEl.name === "Sales Grand Total") {
                obj.selectedRole = "ALL"
                obj.name = "Sales Grand Total"
            } else if (innerEl.name === "Sales Lost Total") {
                obj.selectedRole = "ALL"
                obj.name = "Sales Lost Total"
            } else if (innerEl.name === "Design Lost Total") {
                obj.selectedRole = "ALL"
                obj.name = "Design Lost Total"
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterData,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : "",
                    department: selectedDepartment ? selectedDepartment : ""
                }
            } else if (innerEl === "Sales Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterData,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    selectedRole: "ALL",
                    name: "Sales Grand Total",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : "",
                    department: selectedDepartment ? selectedDepartment : ""
                }
            } else if (innerEl === "Sales Lost Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterData,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    name: "Sales Lost Total",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : "",
                    department: selectedDepartment ? selectedDepartment : ""
                }
            } else if (innerEl === "Design Lost Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterData,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    name: "Design Lost Total",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : "",
                    department: selectedDepartment ? selectedDepartment : ""
                }
            } else {
                let expCenter;
                for (let i = 0; i < store.length; i++) {
                    if (store[i].experienceCenterName === innerEl) {
                        expCenter = store[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenter,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : "",
                    department: selectedDepartment ? selectedDepartment : ""
                }
            }
        }
        props.setLoading(true);
        try {
            let response = await HttpService.getDataBasedClickLost(obj);
            setPopMonthData(response.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const calculatePercentageSummary = (month, expCenterData) => {
        const findMonthlyGrandTotal = (key) => {
            const data = expCenterData[key];
            if (!data) return 0;

            for (const innerEl of data) {
                const found = innerEl.monthlyGrandTotal.find(
                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                );
                if (found) return found.totalGrandTotal || 0;
            }
            return 0;
        };

        const grandTotal = findMonthlyGrandTotal("Grand Total");
        const salesGrandTotal = findMonthlyGrandTotal("Sales Grand Total");

        const percentage = (grandTotal && salesGrandTotal) ? ((grandTotal / salesGrandTotal) * 100).toFixed(2) : 0;
        return `${percentage}%`;
    };

    const calculatePercentageCount = (month, expCenterData) => {
        const findMonthlyGrandTotal = (key) => {
            const data = expCenterData[key];
            if (!data) return 0;

            for (const innerEl of data) {
                const found = innerEl.monthlyGrandTotal.find(
                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                );
                if (found) return found.count || 0;
            }
            return 0;
        };

        const grandTotal = findMonthlyGrandTotal("Grand Total");
        const salesGrandTotal = findMonthlyGrandTotal("Sales Grand Total");

        const percentage = (grandTotal && salesGrandTotal) ? ((grandTotal / salesGrandTotal) * 100).toFixed(2) : 0;
        return `${percentage}%`;
    };

    const percentageLost = (store) => {
        let grandTotalValue = 0;
        let salesGrandTotalValue = 0;

        store.forEach(storeItem => {
            if (storeItem.experienceCenterName === "Grand Total") {
                grandTotalValue = storeItem.grandTotal;
            } else if (storeItem.experienceCenterName === "Sales Grand Total") {
                salesGrandTotalValue = storeItem.grandTotal;
            }
        });
        let percentageResult = 0;
        if (salesGrandTotalValue !== 0) {
            percentageResult = (grandTotalValue / salesGrandTotalValue) * 100;
        }

        return percentageResult.toFixed(2);
    }

    const percentageCount = (store) => {
        let grandTotalValue = 0;
        let salesGrandTotalValue = 0;

        store.forEach(storeItem => {
            if (storeItem.experienceCenterName === "Grand Total") {
                grandTotalValue = storeItem.count;
            } else if (storeItem.experienceCenterName === "Sales Grand Total") {
                salesGrandTotalValue = storeItem.count;
            }
        });
        let percentageResult = 0;
        if (salesGrandTotalValue !== 0) {
            percentageResult = (grandTotalValue / salesGrandTotalValue) * 100;
        }

        return percentageResult.toFixed(2);
    }

    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        lostDataAnalysis(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
    }


    return (
        <div className="App">
            <br />
            <div>
                <Paper className={classes.paper}>
                <Grid
                        container
                        spacing={2}
                        justifyContent={
                            userDetails?.roles && userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                            )
                                ? "flex-start"
                                : "center"
                        }
                        alignItems="center"
                    >
                        {userDetails?.roles &&
                            userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedLocation}
                                            onChange={handleMultipleLocationData}
                                            options={commonLocation}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Location"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        {userDetails?.roles &&
                            userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.4rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedExperienceCenter}
                                            onChange={handleMultipleExpData}
                                            options={commonExpCenter}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Exp-Center"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="From Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="End Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handlePivotDateFilter}
                                style={{
                                    backgroundColor: "#F50057",
                                    color: "#fff",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                className={classes.submitButton}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                <TextField
                                    select
                                    labelId="project-doc"
                                    label="5 % Payment"
                                    variant="outlined"
                                    value={selectedValue}
                                    onChange={(e) => handleSelectChange(e)}
                                >
                                    <MenuItem value="2">All</MenuItem>
                                    <MenuItem value="1">YES</MenuItem>
                                    <MenuItem value="0">NO</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>

                        {/* {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Department"
                                            variant="outlined"
                                            value={selectedDepartment}
                                            onChange={(e) => handleSelectDepartment(e)}
                                        >
                                            <MenuItem value="Sales">Sales</MenuItem>
                                            <MenuItem value="Design">Design</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                            </>
                        )} */}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                        >
                                            {/* Create an array of MenuItem elements instead of using a fragment */}
                                            {[
                                                <MenuItem key="ALL" value="ALL">ALL</MenuItem>,
                                                ...(userDetails.departmentId === salesDepartment ? [
                                                    <MenuItem key={ROLENAME.DGM_Sales} value={ROLENAME.DGM_Sales}>DGM Sales</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesManager} value={ROLENAME.SalesManager}>Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Sales Executive</MenuItem>
                                                ] : [
                                                    <MenuItem key={ROLENAME.DGM_Design} value={ROLENAME.DGM_Design}>DGM Design</MenuItem>,
                                                    <MenuItem key={ROLENAME.OperationDesignManager} value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                ])
                                            ]}
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.SalesManager, ROLENAME.OperationDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                        >
                                            {/* Create an array of MenuItem elements instead of using a fragment */}
                                            {[
                                                ...(userDetails.departmentId === salesDepartment ? [
                                                    <MenuItem key={ROLENAME.SalesManager} value={ROLENAME.SalesManager}>Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Sales Executive</MenuItem>
                                                ] : [
                                                    <MenuItem key={ROLENAME.OperationDesignManager} value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                ])
                                            ]}
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantSalesManager, ROLENAME.AssistantDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                        >
                                            {/* Create an array of MenuItem elements instead of using a fragment */}
                                            {[
                                                ...(userDetails.departmentId === salesDepartment ? [
                                                    <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Sales Executive</MenuItem>
                                                ] : [
                                                    <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                ])
                                            ]}
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            size="medium"
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                    </Grid>

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            <div>
                <>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2} >
                            <Button
                                style={{
                                    backgroundColor: '#1C375D',
                                    color: '#FFF2EB',
                                    marginBottom: '10px',

                                }}
                            >
                                Lost Summary-Values
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                    <StyledTableRow>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Sales Month</StyledTableCell>
                                        {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{
                                                    fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                                                    fontWeight: index === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                    textAlign: 'center',
                                                    position: 'sticky',
                                                    cursor: 'pointer',
                                                    top: 0,
                                                    zIndex: 1, // Ensure the same zIndex for all cells
                                                }}
                                            >
                                                <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                    {/* <span>
                                                {experienceCenterName.expCenterCode} <InfoIcon />
                                                </span> */}
                                                    <span style={{ cursor: "pointer" }}>
                                                        {experienceCenterName.expCenterCode}
                                                    </span>
                                                </Tooltip>

                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Sales Lost Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Design Lost Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Lost Grand Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Sales Grand Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Percentage
                                        </StyledTableCell>


                                    </StyledTableRow>
                                </TableHead>

                                <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                        <StyledTableRow key={monthIndex}>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, textAlign: "center" }}>
                                                {`${month.monthName.slice(0, 3)}-${month.year % 100} `}
                                            </StyledTableCell>

                                            {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                <>
                                                    {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                        <StyledTableCell
                                                            className={classes.bordercolors}
                                                            key={dataIndex}
                                                            style={{
                                                                textAlign: "center",
                                                                cursor: "pointer",
                                                                top: 0,
                                                                background: "white",
                                                                fontWeight: (expCenterIndex === uniqueexperienceCenterNames.length - 1 || expCenterIndex === uniqueexperienceCenterNames.length - 2 || expCenterIndex === uniqueexperienceCenterNames.length - 3 || expCenterIndex === uniqueexperienceCenterNames.length - 4) ? 'bolder' : 'normal',
                                                                color: (expCenterIndex === uniqueexperienceCenterNames.length - 1 || expCenterIndex === uniqueexperienceCenterNames.length - 2 || expCenterIndex === uniqueexperienceCenterNames.length - 3 || expCenterIndex === uniqueexperienceCenterNames.length - 4) ? "#355025" : "#1C375D"
                                                            }}
                                                            onClick={(e) => lostDataBasedOnClick(e, month, innerEl, 'value')}
                                                        >
                                                            {
                                                                formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.totalGrandTotal || 0
                                                                )
                                                            }
                                                        </StyledTableCell>
                                                    ))}
                                                </>
                                            ))}
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                style={{
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                    top: 0,
                                                    background: "white",
                                                    fontWeight: 'bolder',
                                                    color: "#004d40"
                                                }}
                                            >
                                                {calculatePercentageSummary(month, expCenterData)}
                                            </StyledTableCell>

                                        </StyledTableRow>
                                    ))}

                                    <StyledTableRow>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Grand Total</StyledTableCell>
                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => lostDataBasedOnClick(e, store[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                {
                                                    formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.grandTotal : 0), 0))
                                                }
                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }}>
                                            {`${percentageLost(store)}`}%
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>


                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2}>
                            <Button
                                style={{
                                    backgroundColor: '#1C375D',
                                    color: '#FFF2EB',
                                    marginTop: '20px',

                                }}
                            >
                                Total No of Customers
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                    <StyledTableRow>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Sales Month</StyledTableCell>
                                        {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                                            <StyledTableCell className={classes.bordercolors} key={index}
                                                style={{
                                                    fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                                                    fontWeight: index === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                    textAlign: 'center',
                                                    position: 'sticky',
                                                    cursor: 'pointer',
                                                    top: 0,
                                                    zIndex: 1, // Ensure the same zIndex for all cells
                                                }}>
                                                <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                    <span style={{ cursor: "pointer" }}>
                                                        {experienceCenterName.expCenterCode}
                                                    </span>
                                                </Tooltip>
                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Sales Lost Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Design Lost Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Lost Grand Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Sales Grand Total
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Percentage
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                        <StyledTableRow key={monthIndex}>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, textAlign: "center" }}>
                                                {`${month.monthName.slice(0, 3)}-${month.year % 100} `}
                                            </StyledTableCell>
                                            {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                <>
                                                    {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                        <StyledTableCell
                                                            className={classes.bordercolors}
                                                            key={dataIndex}
                                                            style={{
                                                                textAlign: "center",
                                                                cursor: "pointer",
                                                                cursor: "pointer",
                                                                color: "blue",
                                                                textDecoration: "underline",
                                                                background: "white",
                                                                fontWeight: (expCenterIndex === uniqueexperienceCenterNames.length - 1 || expCenterIndex === uniqueexperienceCenterNames.length - 2 || expCenterIndex === uniqueexperienceCenterNames.length - 3 || expCenterIndex === uniqueexperienceCenterNames.length - 4) ? 'bolder' : 'normal',
                                                                color: (expCenterIndex === uniqueexperienceCenterNames.length - 1 || expCenterIndex === uniqueexperienceCenterNames.length - 2 || expCenterIndex === uniqueexperienceCenterNames.length - 3 || expCenterIndex === uniqueexperienceCenterNames.length - 4) ? "#355025" : "#1C375D"
                                                            }}
                                                            onClick={(e) => lostDataBasedOnClick(e, month, innerEl, 'value')}
                                                        >
                                                            {
                                                                formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.count || 0
                                                                )
                                                            }
                                                        </StyledTableCell>
                                                    ))}
                                                </>
                                            ))}
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                style={{
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                    top: 0,
                                                    background: "white",
                                                    fontWeight: 'bolder',
                                                    color: "#004d40"
                                                }}
                                            >
                                                {calculatePercentageCount(month, expCenterData)}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}

                                    <StyledTableRow>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Grand Total</StyledTableCell>
                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => lostDataBasedOnClick(e, store[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                {
                                                    formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.count : 0), 0))
                                                }
                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }}>
                                            {`${percentageCount(store)}`}%
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>
                </>
            </div>
            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                    <StyledTableCell>Logs Stage</StyledTableCell>
                                    <StyledTableCell>Sales Stage</StyledTableCell>
                                    <StyledTableCell>Lost Stage</StyledTableCell>

                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData && popMonthData.map((data, i) => {
                                    return (
                                        <>
                                            <StyledTableRow key={i}>
                                                <StyledTableCell>{i + 1}</StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.erpProjectNo ? (
                                                        <Link
                                                            to={`/project-logs/${data?.leadId?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.leadId?.erpProjectNo}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.lead_no ? (
                                                        <Link
                                                            to={`/project-logs/${data?.leadId?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.leadId?.lead_no}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.customerId?.name}
                                                </StyledTableCell>

                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.staticSalesWonBudget ? data?.leadId?.staticSalesWonBudget : "N/A"}
                                                </StyledTableCell>


                                                <StyledTableCell component="th">
                                                    {data?.salesExpCenter?.locationId?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.salesExpCenter?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.SalesWonDate ? moment(data?.SalesWonDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadId?.currentStage}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.stage}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadId?.salesStage}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.lostStage}
                                                </StyledTableCell>
                                            </StyledTableRow>

                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(LostDataAnalysis);